import { getBetStatusLabelProps, getTotalReturnProps, getBetSummaryProps, isBonusAvailable, getBonusDetailsListProps, getBetTitleCastBetProps, getSelectionTitlesListProps } from "../bet";
import { getEventDetailsRaceProps } from "../selection";
export const getCastBetProps = (bet, state) => {
    let castBetProps = {
        betTitle: getBetTitleCastBetProps(bet, state),
        betStatusLabel: getBetStatusLabelProps(bet, state),
        selectionTitlesList: getSelectionTitlesListProps(bet, state),
        totalReturn: getTotalReturnProps(bet, state),
        eventDetails: getEventDetailsRaceProps(bet.type, bet.selections[0], state),
        betSummary: getBetSummaryProps(bet, state)
    };
    if (isBonusAvailable(bet)) {
        castBetProps.bonusDetailsList = getBonusDetailsListProps(bet, state);
    }
    return castBetProps;
};
//# sourceMappingURL=getCastBetProps.js.map